import React, {Component} from 'react';
import ReactPlaceholder from 'react-placeholder';
import PropTypes from "prop-types";

const propTypes = {
    children: PropTypes.element,
    type: PropTypes.string, //text, media, textRow, rect, round
    ready: PropTypes.bool,
    rows: PropTypes.number, //any whole number
};

class PlaceHolderComponent extends Component {

    render() {

        const {ready, children, rows, type, style} = this.props;

        return (
            <ReactPlaceholder
                showLoadingAnimation={true}
                type={type}
                ready={ready}
                rows={rows} style={style}>
                <div>
                    {
                        children
                    }
                </div>
            </ReactPlaceholder>
        );
    }
}

PlaceHolderComponent.propTypes = propTypes;
export default PlaceHolderComponent;
